
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { LoadingSpinner } from "../GameObjects/LoadingSpinner";

export class Interstitial extends HLF.LoadScreen {
    private _bg!: PIXI.Sprite;
    private _spinner!: LoadingSpinner;
    private _showSpinnerTimer: TimelineLite | undefined;

    public init(pSize: PIXI.Point) {
        this._bg = HLF.PixiUtils.makeSprite("black2x2", Constants.SPRITESHEET_UI);
        this._bg.interactive = true;
        this._bg.scale.set(this._size.x, this._size.y);
        this.addChild(this._bg);

        this._spinner = new LoadingSpinner();
        this.addChild(this._spinner);

        this.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void): void {
        // pOnComplete();
        this._showSpinnerTimer = new TimelineLite();
        this._showSpinnerTimer.call(this._spinner.show.bind(this._spinner), undefined, this, 0.5);
        this._showSpinnerTimer.call(pOnComplete);
    }

    public animateOut(pOnComplete: () => void): void {
        this.killShowSpinnerTimer();
        const timeline: TimelineLite = new TimelineLite();
        timeline.add(this._spinner.hide());
        timeline.call(pOnComplete);
    }

    public onLoadComplete(pCallback: () => void): void {
        pCallback();
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        if (this._bg !== undefined) {
            this._bg.scale.set(this._size.x, this._size.y);
        }
    }

    private killShowSpinnerTimer(): void {
        if (this._showSpinnerTimer !== undefined) {
            this._showSpinnerTimer.kill();
        }
    }
}
